import { gql } from "@apollo/client";

const INITIALIZE_PAYMENT_INTENT = gql`
  mutation InitializePaymentIntent(
    $userId: ID!
    $amount: Decimal128!
    $accountId: String!
    $accessToken: String
    $productId: ID!
  ) {
    initializePaymentIntent(
      userId: $userId
      amount: $amount
      accountId: $accountId
      accessToken: $accessToken
      productId: $productId
    ) {
      transferIntentId
      linkToken
    }
  }
`;

const SANDBOX_SIMULATE_AVAILABLE_FUNDS = gql`
  mutation SandboxSimulateAvailableFunds {
    sandboxSimulateAvailableFunds
  }
`;

const SANDBOX_SIMULATE_SWEEP = gql`
  mutation SandboxSimulateSweep {
    sandboxSimulateSweep
  }
`;

const SAVE_ACCESS_TOKEN_AND_EXCHANGE_PUBLIC_TOKEN = gql`
  mutation SaveAccessTokenAndExchangePublicToken(
    $userId: ID!
    $publicToken: String!
    $returnAccountId: ID
  ) {
    saveAccessTokenAndExchangePublicToken(
      userId: $userId
      publicToken: $publicToken
      returnAccountId: $returnAccountId
    )
  }
`;

const COMPLETE_PLAID_PAYMENT = gql`
  mutation CompletePlaidPayment($userId: ID!, $transferIntentId: String!) {
    completePlaidPayment(userId: $userId, transferIntentId: $transferIntentId)
  }
`;

const GET_LINK_TOKEN_EMBEDDED = gql`
  mutation GetLinkTokenService($userId: ID!, $accountId: String!) {
    getLinkTokenService(userId: $userId, accountId: $accountId)
  }
`;

const DELETE_PLAID_USER_ACCESS_TOKEN = gql`
  mutation DeletePlaidUserAccessToken($userId: ID!, $accessToken: String!) {
    deletePlaidUserAccessToken(userId: $userId, accessToken: $accessToken)
  }
`;

const CALL_UPDATE_PLAID_TRANSFER_SWEEPS = gql`
  mutation UpdatePlaidTransfersSweeps {
    updatePlaidTransfersSweeps
  }
`;

export {
  INITIALIZE_PAYMENT_INTENT,
  SANDBOX_SIMULATE_AVAILABLE_FUNDS,
  SANDBOX_SIMULATE_SWEEP,
  SAVE_ACCESS_TOKEN_AND_EXCHANGE_PUBLIC_TOKEN,
  COMPLETE_PLAID_PAYMENT,
  GET_LINK_TOKEN_EMBEDDED,
  DELETE_PLAID_USER_ACCESS_TOKEN,
  CALL_UPDATE_PLAID_TRANSFER_SWEEPS,
};
